var $ = require('jquery')
  , md5 = require('./md5')

function GetDownloadInfo(gameCodes) {
    this.appId = 'yQWbAjGE';
    this.appKey = '1cas9ubnk1ZfWuMZ';
    this.gameCodes = gameCodes;
    // this.getUrls();
}

GetDownloadInfo.prototype = {
  getPlatformUrl: function(gameCode, needSource) {
    var that = this;
    if (gameCode) {
      var nonce = Math.ceil(Math.ceil(new Date().getTime() / 1000) / (60 / 2)) + 17173,
          timestamp = new Date().getTime();
      var url = 'https://dmanage.17173.com/api/downloadUrl';
      if (needSource) {
        url = 'https://dmanage.17173.com/api/downloadUrlAndSource'
      }
      return $.ajax({
        url: url,
        dataType: 'jsonp',
        data: {
          nonce: nonce,
          sign: md5('gameCode=' + gameCode + '&nonce=' + nonce + '&time=' + timestamp + '&appKey=' + that.appKey + ''),
          time: timestamp,
          gameCode: gameCode,
          appId: that.appId
        }
      })
    }
    return null;
  },
  getUrls: function(callback) {
    var that = this;

    $.when(that.getPlatformUrl(that.gameCodes.ios), that.getPlatformUrl(that.gameCodes.android), that.getPlatformUrl(that.gameCodes.pc)).then(function (res1, res2, res3) {
      var data = {};
      if (that.gameCodes.ios && res1[0].data) {
          data.ios = res1[0].data;
      }

      if (that.gameCodes.android && res2[0].data) {
          data.android = res2[0].data;
      }

      if (that.gameCodes.pc && res3[0].data) {
        data.pc = res3[0].data;
      }

      if ($.isFunction(callback)) {
        this.callback = callback(data);
      }
    })
  }
}

module.exports = GetDownloadInfo